/**
 * Microsoft Entra ID (Azure AD) authentication configuration
 */

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '723a64da-3b38-4f54-acbe-430f5132937f',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'd7e1f7a3-f5ee-4f2d-b268-857033f11613'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes for the access token
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// API scopes (for calling your backend)
export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID || '723a64da-3b38-4f54-acbe-430f5132937f'}/access_as_user`],
};

// Check if auth is enabled
export const isAuthEnabled = () => {
  const enabled = process.env.REACT_APP_AUTH_ENABLED;
  // Default to true in production, false in development
  if (enabled === undefined) {
    return process.env.NODE_ENV === 'production';
  }
  return enabled === 'true';
};
